import { PURGE } from "redux-persist";

interface OnlineSession {
  uuid: string;
  [key: string]: any;
}

const initialState = {
  onlineSessions: [] as OnlineSession[],
};

export default (state = initialState, { type, payload }: any) => {
  switch (type) {
    case "CREATE_ONLINE_SESSION":
      return {
        ...state,
        onlineSessions: [...state.onlineSessions, payload],
      };
    case "JOIN_ONLINE_SESSION":
      return {
        ...state,
        notes: state.onlineSessions.map((onlineSession: OnlineSession) =>
          onlineSession.channelName === payload.channelName
            ? {
                ...onlineSession,
                ...payload,
              }
            : onlineSession
        ),
      };
    case "UPDATE_ONLINE_SESSION":
      return {
        ...state,
        onlineSessions: state.onlineSessions.map((session: OnlineSession) =>
          session.uuid === payload.uuid ? { ...session, ...payload } : session
        ),
      };
    case "CLEAR_ORGANIZATION_DATA":
      return initialState;
    case PURGE:
      return initialState;
    default:
      return state;
  }
};
